import { render, staticRenderFns } from "./SfBreadcrumbs.vue?vue&type=template&id=6577a840&functional=true"
import script from "./SfBreadcrumbs.vue?vue&type=script&lang=js"
export * from "./SfBreadcrumbs.vue?vue&type=script&lang=js"
function injectStyles (context) {
  
  var style0 = require("./SfBreadcrumbs.vue?vue&type=style&index=0&id=6577a840&prod&lang=scss")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  injectStyles,
  null,
  "de5b2a7a"
  
)

export default component.exports